import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ModuleDataToCreate, CardBlockImage } from "../types";
import { saveContentBlocksImages } from "./saveContentBlocksImages";
import { saveTopPrivacyTipsBlockImage } from "./saveTopPrivacyTipsBlockImage";

export const createModuleTemplate = async (
  moduleData: ModuleDataToCreate,
  threeCardBlockImages: CardBlockImage[],
  topPrivacyTipsBlockImage: CardBlockImage,
): Promise<void> => {
  const collectionRef = collection(db, "moduleTemplates");
  const createdModuleDoc = await addDoc(collectionRef, {
    ...moduleData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });

  if (threeCardBlockImages.some((item) => item instanceof File)) {
    await saveContentBlocksImages({
      moduleId: createdModuleDoc.id,
      threeCardBlockImages,
    });
  }

  if (topPrivacyTipsBlockImage instanceof File) {
    await saveTopPrivacyTipsBlockImage({
      moduleId: createdModuleDoc.id,
      topPrivacyTipsBlockImage,
    });
  }
};
